import { render, staticRenderFns } from "./PcPcmRegnTap1Table.vue?vue&type=template&id=199eb74e&"
import script from "./PcPcmRegnTap1Table.vue?vue&type=script&lang=js&"
export * from "./PcPcmRegnTap1Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports